import { IBGEDistrict } from './ibge-service';

// ============================================================================
// RIO DE JANEIRO - RJ (152 Bairros Oficiais com GPS e Densidade Populacional)
// ============================================================================
export const RIO_DE_JANEIRO_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- ZONA SUL ---
  { nome: 'Copacabana', lat: -22.9698, lng: -43.1869, population: 147000 },
  { nome: 'Ipanema', lat: -22.9838, lng: -43.2045, population: 43000 },
  { nome: 'Leblon', lat: -22.9841, lng: -43.2241, population: 46000 },
  { nome: 'Botafogo', lat: -22.9510, lng: -43.1843, population: 83000 },
  { nome: 'Flamengo', lat: -22.9324, lng: -43.1764, population: 53000 },
  { nome: 'Laranjeiras', lat: -22.9360, lng: -43.1908, population: 46000 },
  { nome: 'Catete', lat: -22.9257, lng: -43.1772, population: 24000 },
  { nome: 'Glória', lat: -22.9205, lng: -43.1769, population: 10000 },
  { nome: 'Humaitá', lat: -22.9575, lng: -43.1978, population: 12000 },
  { nome: 'Urca', lat: -22.9469, lng: -43.1642, population: 7000 },
  { nome: 'Leme', lat: -22.9633, lng: -43.1697, population: 15000 },
  { nome: 'Jardim Botânico', lat: -22.9678, lng: -43.2269, population: 18000 },
  { nome: 'Gávea', lat: -22.9753, lng: -43.2292, population: 17000 },
  { nome: 'Lagoa', lat: -22.9733, lng: -43.2072, population: 21000 },
  { nome: 'São Conrado', lat: -22.9989, lng: -43.2542, population: 12000 },
  { nome: 'Cosme Velho', lat: -22.9419, lng: -43.1989, population: 7000 },
  { nome: 'Rocinha', lat: -22.9889, lng: -43.2489, population: 70000 },
  { nome: 'Vidigal', lat: -22.9942, lng: -43.2389, population: 13000 },

  // --- BARRA DA TIJUCA, RECREIO & JACAREPAGUÁ ---
  { nome: 'Barra da Tijuca', lat: -23.0004, lng: -43.3659, population: 135000 },
  { nome: 'Jardim Oceânico (Barra)', lat: -23.0089, lng: -43.3106, population: 30000 },
  { nome: 'Parque das Rosas / Península (Barra)', lat: -22.9972, lng: -43.3542, population: 35000 },
  { nome: 'Recreio dos Bandeirantes', lat: -23.0289, lng: -43.4686, population: 110000 },
  { nome: 'Pontal do Recreio', lat: -23.0389, lng: -43.4914, population: 20000 },
  { nome: 'Barra Olímpica', lat: -22.9789, lng: -43.3889, population: 40000 },
  { nome: 'Jacarepaguá', lat: -22.9389, lng: -43.3689, population: 160000 },
  { nome: 'Freguesia de Jacarepaguá', lat: -22.9286, lng: -43.3403, population: 75000 },
  { nome: 'Taquara', lat: -22.9189, lng: -43.3714, population: 105000 },
  { nome: 'Pechincha', lat: -22.9358, lng: -43.3556, population: 38000 },
  { nome: 'Anil', lat: -22.9519, lng: -43.3389, population: 26000 },
  { nome: 'Curicica', lat: -22.9589, lng: -43.3856, population: 32000 },
  { nome: 'Camorim', lat: -22.9689, lng: -43.4189, population: 5000 },
  { nome: 'Vargem Grande', lat: -22.9919, lng: -43.4958, population: 18000 },
  { nome: 'Vargem Pequena', lat: -22.9889, lng: -43.4589, population: 15000 },
  { nome: 'Itanhangá', lat: -22.9914, lng: -43.3089, population: 32000 },
  { nome: 'Joá', lat: -23.0119, lng: -43.2889, population: 1200 },
  { nome: 'Praça Seca', lat: -22.8958, lng: -43.3556, population: 65000 },
  { nome: 'Tanque', lat: -22.9108, lng: -43.3589, population: 40000 },
  { nome: 'Gardênia Azul', lat: -22.9619, lng: -43.3514, population: 20000 },
  { nome: 'Cidade de Deus', lat: -22.9489, lng: -43.3619, population: 38000 },

  // --- ZONA NORTE ---
  { nome: 'Tijuca', lat: -22.9250, lng: -43.2389, population: 165000 },
  { nome: 'Vila Isabel', lat: -22.9169, lng: -43.2489, population: 85000 },
  { nome: 'Grajaú', lat: -22.9219, lng: -43.2619, population: 40000 },
  { nome: 'Maracanã', lat: -22.9139, lng: -43.2289, population: 28000 },
  { nome: 'Andaraí', lat: -22.9269, lng: -43.2542, population: 40000 },
  { nome: 'Alto da Boa Vista', lat: -22.9619, lng: -43.2789, population: 10000 },
  { nome: 'Méier', lat: -22.8989, lng: -43.2789, population: 52000 },
  { nome: 'Cachambi', lat: -22.8919, lng: -43.2719, population: 45000 },
  { nome: 'Todos os Santos', lat: -22.8989, lng: -43.2889, population: 26000 },
  { nome: 'Engenho Novo', lat: -22.9058, lng: -43.2689, population: 42000 },
  { nome: 'Engenho de Dentro', lat: -22.8989, lng: -43.2989, population: 45000 },
  { nome: 'Lins de Vasconcelos', lat: -22.9119, lng: -43.2858, population: 36000 },
  { nome: 'Riachuelo', lat: -22.9019, lng: -43.2619, population: 14000 },
  { nome: 'Rocha', lat: -22.8989, lng: -43.2558, population: 10000 },
  { nome: 'Sampaio', lat: -22.9019, lng: -43.2689, population: 12000 },
  { nome: 'São Francisco Xavier', lat: -22.9058, lng: -43.2458, population: 8000 },
  { nome: 'Água Santa', lat: -22.9089, lng: -43.3119, population: 9000 },
  { nome: 'Encantado', lat: -22.8958, lng: -43.3089, population: 15000 },
  { nome: 'Piedade', lat: -22.8919, lng: -43.3158, population: 45000 },
  { nome: 'Abolição', lat: -22.8858, lng: -43.2989, population: 13000 },
  { nome: 'Pilares', lat: -22.8789, lng: -43.2919, population: 30000 },
  { nome: 'Del Castilho', lat: -22.8789, lng: -43.2719, population: 20000 },
  { nome: 'Maria da Graça', lat: -22.8819, lng: -43.2619, population: 9000 },
  { nome: 'Inhaúma', lat: -22.8719, lng: -43.2819, population: 25000 },
  { nome: 'Higienópolis', lat: -22.8719, lng: -43.2619, population: 18000 },
  { nome: 'Bonsucesso', lat: -22.8689, lng: -43.2542, population: 20000 },
  { nome: 'Ramos', lat: -22.8589, lng: -43.2589, population: 40000 },
  { nome: 'Olaria', lat: -22.8458, lng: -43.2658, population: 63000 },
  { nome: 'Penha', lat: -22.8419, lng: -43.2789, population: 76000 },
  { nome: 'Penha Circular', lat: -22.8358, lng: -43.2919, population: 30000 },
  { nome: 'Brás de Pina', lat: -22.8319, lng: -43.3019, population: 32000 },
  { nome: 'Cordovil', lat: -22.8258, lng: -43.3089, population: 48000 },
  { nome: 'Parada de Lucas', lat: -22.8189, lng: -43.3119, population: 25000 },
  { nome: 'Vigário Geral', lat: -22.8119, lng: -43.3089, population: 40000 },
  { nome: 'Jardim América', lat: -22.8119, lng: -43.3219, population: 25000 },
  { nome: 'Madureira', lat: -22.8719, lng: -43.3389, population: 50000 },
  { nome: 'Cascadura', lat: -22.8819, lng: -43.3319, population: 35000 },
  { nome: 'Campinho', lat: -22.8858, lng: -43.3458, population: 12000 },
  { nome: 'Quintino Bocaiúva', lat: -22.8889, lng: -43.3219, population: 32000 },
  { nome: 'Cavalcanti', lat: -22.8719, lng: -43.3189, population: 16000 },
  { nome: 'Vaz Lobo', lat: -22.8619, lng: -43.3289, population: 15000 },
  { nome: 'Vicente de Carvalho', lat: -22.8558, lng: -43.3158, population: 25000 },
  { nome: 'Vila Kosmos', lat: -22.8519, lng: -43.3119, population: 18000 },
  { nome: 'Vila da Penha', lat: -22.8489, lng: -43.3189, population: 26000 },
  { nome: 'Irajá', lat: -22.8358, lng: -43.3289, population: 98000 },
  { nome: 'Colégio', lat: -22.8419, lng: -43.3389, population: 28000 },
  { nome: 'Rocha Miranda', lat: -22.8519, lng: -43.3489, population: 42000 },
  { nome: 'Honório Gurgel', lat: -22.8458, lng: -43.3619, population: 22000 },
  { nome: 'Oswaldo Cruz', lat: -22.8658, lng: -43.3519, population: 34000 },
  { nome: 'Bento Ribeiro', lat: -22.8619, lng: -43.3658, population: 45000 },
  { nome: 'Marechal Hermes', lat: -22.8619, lng: -43.3758, population: 50000 },
  { nome: 'Guadalupe', lat: -22.8419, lng: -43.3719, population: 48000 },
  { nome: 'Anchieta', lat: -22.8258, lng: -43.4019, population: 56000 },
  { nome: 'Ricardo de Albuquerque', lat: -22.8419, lng: -43.3989, population: 26000 },
  { nome: 'Pavuna', lat: -22.8119, lng: -43.3658, population: 96000 },
  { nome: 'Costa Barros', lat: -22.8219, lng: -43.3558, population: 35000 },
  { nome: 'Acari', lat: -22.8289, lng: -43.3419, population: 28000 },
  { nome: 'Coelho Neto', lat: -22.8358, lng: -43.3489, population: 38000 },

  // --- ILHA DO GOVERNADOR & FUNDÃO ---
  { nome: 'Jardim Guanabara (Ilha)', lat: -22.8119, lng: -43.1958, population: 30000 },
  { nome: 'Portuguesa (Ilha)', lat: -22.7989, lng: -43.2058, population: 28000 },
  { nome: 'Cacuia (Ilha)', lat: -22.8089, lng: -43.1858, population: 12000 },
  { nome: 'Cocotá (Ilha)', lat: -22.8019, lng: -43.1819, population: 15000 },
  { nome: 'Ribeira (Ilha)', lat: -22.8258, lng: -43.1758, population: 5000 },
  { nome: 'Zumbi (Ilha)', lat: -22.8219, lng: -43.1758, population: 3000 },
  { nome: 'Pitangueiras (Ilha)', lat: -22.8189, lng: -43.1719, population: 11000 },
  { nome: 'Praia da Bandeira (Ilha)', lat: -22.8158, lng: -43.1719, population: 6000 },
  { nome: 'Freguesia da Ilha', lat: -22.7889, lng: -43.1789, population: 20000 },
  { nome: 'Bancários (Ilha)', lat: -22.7958, lng: -43.1889, population: 13000 },
  { nome: 'Tauá (Ilha)', lat: -22.7958, lng: -43.1789, population: 30000 },
  { nome: 'Galeão (Ilha / Aeroporto)', lat: -22.8119, lng: -43.2458, population: 22000 },
  { nome: 'Cidade Universitária (Fundão / UFRJ)', lat: -22.8589, lng: -43.2319, population: 5000 },
  { nome: 'Ilha de Paquetá', lat: -22.7589, lng: -43.1089, population: 3500 },

  // --- CENTRO & ÁREA PORTUÁRIA ---
  { nome: 'Centro Comercial / Financeiro', lat: -22.9068, lng: -43.1729, population: 42000 },
  { nome: 'Lapa', lat: -22.9133, lng: -43.1819, population: 10000 },
  { nome: 'Santa Teresa', lat: -22.9219, lng: -43.1908, population: 40000 },
  { nome: 'Castelo / Praça XV', lat: -22.9028, lng: -43.1742, population: 8000 },
  { nome: 'Cinelândia / Carioca', lat: -22.9089, lng: -43.1758, population: 6000 },
  { nome: 'Saúde / Porto Maravilha', lat: -22.8958, lng: -43.1889, population: 8000 },
  { nome: 'Gamboa', lat: -22.8989, lng: -43.1958, population: 13000 },
  { nome: 'Santo Cristo', lat: -22.8989, lng: -43.2089, population: 11000 },
  { nome: 'Caju', lat: -22.8858, lng: -43.2189, population: 20000 },
  { nome: 'Estácio', lat: -22.9142, lng: -43.2045, population: 18000 },
  { nome: 'Cidade Nova', lat: -22.9089, lng: -43.2045, population: 6000 },
  { nome: 'Praça da Bandeira', lat: -22.9089, lng: -43.2142, population: 9000 },
  { nome: 'Rio Comprido', lat: -22.9258, lng: -43.2106, population: 45000 },
  { nome: 'São Cristóvão', lat: -22.8989, lng: -43.2242, population: 25000 },
  { nome: 'Benfica', lat: -22.8919, lng: -43.2389, population: 26000 },
  { nome: 'Mangueira', lat: -22.9058, lng: -43.2389, population: 18000 },
  { nome: 'Vasco da Gama', lat: -22.8958, lng: -43.2289, population: 10000 },

  // --- ZONA OESTE (ALTA DENSIDADE) ---
  { nome: 'Campo Grande Centro', lat: -22.9019, lng: -43.5589, population: 330000 },
  { nome: 'Santa Cruz', lat: -22.9189, lng: -43.6858, population: 220000 },
  { nome: 'Bangu Centro', lat: -22.8789, lng: -43.4689, population: 250000 },
  { nome: 'Realengo', lat: -22.8789, lng: -43.4319, population: 180000 },
  { nome: 'Padre Miguel', lat: -22.8789, lng: -43.4489, population: 65000 },
  { nome: 'Sulacap', lat: -22.8889, lng: -43.3989, population: 35000 },
  { nome: 'Magalhães Bastos', lat: -22.8789, lng: -43.4119, population: 25000 },
  { nome: 'Deodoro', lat: -22.8589, lng: -43.3858, population: 12000 },
  { nome: 'Vila Militar', lat: -22.8689, lng: -43.3989, population: 14000 },
  { nome: 'Senador Camará', lat: -22.8858, lng: -43.4919, population: 105000 },
  { nome: 'Santíssimo', lat: -22.8719, lng: -43.5189, population: 42000 },
  { nome: 'Senador Vasconcelos', lat: -22.8858, lng: -43.5358, population: 26000 },
  { nome: 'Inhoaíba', lat: -22.8989, lng: -43.5858, population: 55000 },
  { nome: 'Cosmos', lat: -22.9058, lng: -43.6189, population: 70000 },
  { nome: 'Paciência', lat: -22.9019, lng: -43.6419, population: 95000 },
  { nome: 'Sepetiba', lat: -22.9719, lng: -43.7019, population: 40000 },
  { nome: 'Guaratiba', lat: -23.0019, lng: -43.6019, population: 40000 },
  { nome: 'Barra de Guaratiba', lat: -23.0689, lng: -43.5689, population: 5000 },
  { nome: 'Pedra de Guaratiba', lat: -22.9989, lng: -43.6389, population: 15000 }
];

// ============================================================================
// BRASÍLIA / DISTRITO FEDERAL (46 Polos & RAs Comerciais com GPS)
// ============================================================================
export const BRASILIA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- PLANO PILOTO & NOBRES ---
  { nome: 'Asa Sul', lat: -15.8089, lng: -47.9019, population: 85000 },
  { nome: 'Asa Norte', lat: -15.7619, lng: -47.8819, population: 90000 },
  { nome: 'Setor Comercial Sul (SCS)', lat: -15.7958, lng: -47.8919, population: 10000 },
  { nome: 'Setor Comercial Norte (SCN)', lat: -15.7889, lng: -47.8889, population: 10000 },
  { nome: 'Setor Hoteleiro Sul / Norte', lat: -15.7919, lng: -47.8958, population: 5000 },
  { nome: 'Setor Bancário Sul / Norte', lat: -15.7958, lng: -47.8819, population: 6000 },
  { nome: 'Setor de Autarquias / Ministérios', lat: -15.7989, lng: -47.8689, population: 8000 },
  { nome: 'Sudoeste', lat: -15.7989, lng: -47.9289, population: 55000 },
  { nome: 'Noroeste', lat: -15.7519, lng: -47.9158, population: 28000 },
  { nome: 'Octogonal', lat: -15.8089, lng: -47.9358, population: 12000 },
  { nome: 'Cruzeiro Velho', lat: -15.7919, lng: -47.9389, population: 18000 },
  { nome: 'Cruzeiro Novo', lat: -15.7858, lng: -47.9419, population: 15000 },
  { nome: 'Lago Sul', lat: -15.8458, lng: -47.8719, population: 30000 },
  { nome: 'Lago Norte', lat: -15.7358, lng: -47.8519, population: 35000 },
  { nome: 'Park Way', lat: -15.8989, lng: -47.9519, population: 22000 },
  { nome: 'Vila Planalto', lat: -15.7919, lng: -47.8519, population: 7000 },
  { nome: 'Candangolândia', lat: -15.8558, lng: -47.9519, population: 17000 },
  { nome: 'Núcleo Bandeirante', lat: -15.8719, lng: -47.9689, population: 25000 },

  // --- CIDADES SATÉLITES DE ALTA DENSIDADE COMERCIAL ---
  { nome: 'Águas Claras Norte', lat: -15.8358, lng: -48.0289, population: 85000 },
  { nome: 'Águas Claras Sul', lat: -15.8489, lng: -48.0358, population: 75000 },
  { nome: 'Taguatinga Centro', lat: -15.8319, lng: -48.0589, population: 90000 },
  { nome: 'Taguatinga Norte', lat: -15.8119, lng: -48.0689, population: 70000 },
  { nome: 'Taguatinga Sul', lat: -15.8519, lng: -48.0519, population: 60000 },
  { nome: 'Setor de Oficinas e Indústrias (Taguatinga)', lat: -15.8289, lng: -48.0819, population: 25000 },
  { nome: 'Vicente Pires', lat: -15.8089, lng: -48.0189, population: 80000 },
  { nome: 'Ceilândia Centro', lat: -15.8189, lng: -48.1119, population: 120000 },
  { nome: 'Ceilândia Norte', lat: -15.7989, lng: -48.1189, population: 110000 },
  { nome: 'Ceilândia Sul', lat: -15.8389, lng: -48.1058, population: 100000 },
  { nome: 'P Sul / P Norte (Ceilândia)', lat: -15.8458, lng: -48.1319, population: 90000 },
  { nome: 'Sol Nascente / Pôr do Sol', lat: -15.8319, lng: -48.1519, population: 95000 },
  { nome: 'Samambaia Norte', lat: -15.8619, lng: -48.0889, population: 130000 },
  { nome: 'Samambaia Sul', lat: -15.8819, lng: -48.0789, population: 125000 },
  { nome: 'Guará I', lat: -15.8219, lng: -47.9789, population: 65000 },
  { nome: 'Guará II', lat: -15.8319, lng: -47.9889, population: 65000 },
  { nome: 'Setor de Garagens e Concessionárias (SIA)', lat: -15.8019, lng: -47.9619, population: 15000 },
  { nome: 'Setor de Indústria e Abastecimento (SIA)', lat: -15.8119, lng: -47.9689, population: 20000 },
  { nome: 'Setor de Armazenagem e Abastecimento (SAAN)', lat: -15.7619, lng: -47.9389, population: 10000 },
  { nome: 'Gama Centro / Setor Sul', lat: -16.0189, lng: -48.0619, population: 80000 },
  { nome: 'Gama Norte / Oeste', lat: -15.9989, lng: -48.0719, population: 65000 },
  { nome: 'Sobradinho I', lat: -15.6519, lng: -47.7919, population: 75000 },
  { nome: 'Sobradinho II', lat: -15.6319, lng: -47.8189, population: 45000 },
  { nome: 'Planaltina Centro e Setores', lat: -15.6219, lng: -47.6519, population: 190000 },
  { nome: 'Santa Maria', lat: -16.0119, lng: -47.9889, population: 130000 },
  { nome: 'Recanto das Emas', lat: -15.9089, lng: -48.0689, population: 150000 },
  { nome: 'Riacho Fundo I', lat: -15.8819, lng: -48.0189, population: 45000 },
  { nome: 'Riacho Fundo II', lat: -15.8989, lng: -48.0419, population: 55000 },
  { nome: 'São Sebastião', lat: -15.9058, lng: -47.7719, population: 110000 },
  { nome: 'Jardim Botânico (DF)', lat: -15.8719, lng: -47.8189, population: 32000 }
];

// ============================================================================
// SALVADOR - BA (78 Bairros Oficiais com GPS)
// ============================================================================
export const SALVADOR_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- ORLA & CENTRO-SUL ---
  { nome: 'Pituba', lat: -12.9989, lng: -38.4558, population: 70000 },
  { nome: 'Itaigara', lat: -12.9919, lng: -38.4689, population: 35000 },
  { nome: 'Caminho das Árvores', lat: -12.9819, lng: -38.4558, population: 28000 },
  { nome: 'Horto Florestal', lat: -12.9889, lng: -38.4819, population: 18000 },
  { nome: 'Brotas', lat: -12.9819, lng: -38.4919, population: 75000 },
  { nome: 'Graça', lat: -12.9989, lng: -38.5219, population: 25000 },
  { nome: 'Barra', lat: -13.0089, lng: -38.5289, population: 22000 },
  { nome: 'Ondina', lat: -13.0058, lng: -38.5089, population: 18000 },
  { nome: 'Rio Vermelho', lat: -13.0119, lng: -38.4889, population: 30000 },
  { nome: 'Amaralina', lat: -13.0089, lng: -38.4719, population: 20000 },
  { nome: 'Federação', lat: -12.9958, lng: -38.5089, population: 35000 },
  { nome: 'Vitória / Corredor da Vitória', lat: -12.9919, lng: -38.5258, population: 12000 },
  { nome: 'Canela', lat: -12.9919, lng: -38.5189, population: 15000 },
  { nome: 'Campo Grande', lat: -12.9889, lng: -38.5189, population: 14000 },
  { nome: 'Garcia', lat: -12.9858, lng: -38.5119, population: 20000 },
  { nome: 'Nazaré', lat: -12.9789, lng: -38.5058, population: 24000 },
  { nome: 'Comércio / Centro Histórico', lat: -12.9719, lng: -38.5119, population: 16000 },
  { nome: 'Pelourinho', lat: -12.9719, lng: -38.5089, population: 8000 },
  { nome: 'Santo Antônio Além do Carmo', lat: -12.9658, lng: -38.5058, population: 10000 },

  // --- ORLA NORTE & EXPANSÃO ---
  { nome: 'Costa Azul', lat: -12.9919, lng: -38.4419, population: 26000 },
  { nome: 'Armação', lat: -12.9858, lng: -38.4319, population: 16000 },
  { nome: 'Boca do Rio', lat: -12.9789, lng: -38.4219, population: 52000 },
  { nome: 'Imbuí', lat: -12.9719, lng: -38.4319, population: 42000 },
  { nome: 'STIEP', lat: -12.9758, lng: -38.4458, population: 20000 },
  { nome: 'Patamares', lat: -12.9558, lng: -38.4019, population: 25000 },
  { nome: 'Jaguaribe', lat: -12.9489, lng: -38.3919, population: 18000 },
  { nome: 'Piatã', lat: -12.9419, lng: -38.3789, population: 30000 },
  { nome: 'Itapuã', lat: -12.9358, lng: -38.3619, population: 68000 },
  { nome: 'Stella Maris', lat: -12.9289, lng: -38.3389, population: 22000 },
  { nome: 'Praia do Flamengo', lat: -12.9219, lng: -38.3289, population: 12000 },
  { nome: 'Alphaville I e II (Salvador)', lat: -12.9419, lng: -38.4089, population: 15000 },

  // --- MIOLO & ZONA CENTRAL ---
  { nome: 'Cabula', lat: -12.9558, lng: -38.4689, population: 45000 },
  { nome: 'Pernambués', lat: -12.9658, lng: -38.4619, population: 65000 },
  { nome: 'Resgate', lat: -12.9619, lng: -38.4689, population: 16000 },
  { nome: 'Saboeiro', lat: -12.9589, lng: -38.4558, population: 20000 },
  { nome: 'São Gonçalo do Retiro', lat: -12.9589, lng: -38.4789, population: 25000 },
  { nome: 'Narandiba', lat: -12.9519, lng: -38.4419, population: 18000 },
  { nome: 'Doron', lat: -12.9489, lng: -38.4358, population: 14000 },
  { nome: 'Sussuarana', lat: -12.9389, lng: -38.4489, population: 40000 },
  { nome: 'Pau da Lima', lat: -12.9289, lng: -38.4389, population: 60000 },
  { nome: 'São Marcos', lat: -12.9258, lng: -38.4289, population: 48000 },
  { nome: 'São Rafael', lat: -12.9319, lng: -38.4219, population: 35000 },
  { nome: 'Cajazeiras (V a XI)', lat: -12.8989, lng: -38.4119, population: 150000 },
  { nome: 'Fazenda Grande (I a IV)', lat: -12.8889, lng: -38.4019, population: 65000 },
  { nome: 'Águas Claras (Salvador)', lat: -12.8789, lng: -38.4289, population: 45000 },
  { nome: 'Castelo Branco', lat: -12.8919, lng: -38.4289, population: 40000 },

  // --- CIDADE BAIXA & SUBÚRBIO FERROVIÁRIO ---
  { nome: 'Bonfim', lat: -12.9258, lng: -38.5089, population: 18000 },
  { nome: 'Ribeira', lat: -12.9189, lng: -38.4989, population: 20000 },
  { nome: 'Monte Serrat', lat: -12.9319, lng: -38.5189, population: 5000 },
  { nome: 'Roma', lat: -12.9358, lng: -38.5019, population: 15000 },
  { nome: 'Calçada', lat: -12.9458, lng: -38.4989, population: 22000 },
  { nome: 'Mares', lat: -12.9419, lng: -38.4919, population: 14000 },
  { nome: 'Liberdade', lat: -12.9558, lng: -38.4919, population: 58000 },
  { nome: 'Curuzu', lat: -12.9519, lng: -38.4889, population: 20000 },
  { nome: 'São Caetano', lat: -12.9389, lng: -38.4789, population: 65000 },
  { nome: 'Fazenda Grande do Retiro', lat: -12.9458, lng: -38.4689, population: 48000 },
  { nome: 'Lobato', lat: -12.9189, lng: -38.4789, population: 36000 },
  { nome: 'Plataforma', lat: -12.8989, lng: -38.4819, population: 45000 },
  { nome: 'Periperi', lat: -12.8719, lng: -38.4719, population: 60000 },
  { nome: 'Paripe', lat: -12.8489, lng: -38.4689, population: 62000 },
  { nome: 'Itacaranha', lat: -12.8858, lng: -38.4789, population: 22000 },
  { nome: 'Escada', lat: -12.8919, lng: -38.4819, population: 12000 },
  { nome: 'Coutos', lat: -12.8619, lng: -38.4689, population: 28000 },
  { nome: 'Valéria', lat: -12.8619, lng: -38.4389, population: 35000 },
  { nome: 'São Cristóvão (Salvador)', lat: -12.9058, lng: -38.3519, population: 48000 },
  { nome: 'Mussurunga', lat: -12.9189, lng: -38.3689, population: 45000 }
];

// ============================================================================
// FORTALEZA - CE (74 Bairros Oficiais com GPS)
// ============================================================================
export const FORTALEZA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- ALDEOTA, LITORAL & NOBRES ---
  { nome: 'Aldeota', lat: -3.7389, lng: -38.5019, population: 52000 },
  { nome: 'Meireles', lat: -3.7258, lng: -38.4919, population: 42000 },
  { nome: 'Mucuripe', lat: -3.7219, lng: -38.4789, population: 38000 },
  { nome: 'Varjota', lat: -3.7319, lng: -38.4858, population: 15000 },
  { nome: 'Praia de Iracema', lat: -3.7189, lng: -38.5119, population: 8000 },
  { nome: 'Dionísio Torres', lat: -3.7519, lng: -38.5089, population: 20000 },
  { nome: 'Joaquim Távora', lat: -3.7519, lng: -38.5189, population: 25000 },
  { nome: 'Cocó', lat: -3.7519, lng: -38.4789, population: 28000 },
  { nome: 'Papicu', lat: -3.7419, lng: -38.4719, population: 35000 },
  { nome: 'Guararapes', lat: -3.7689, lng: -38.4819, population: 18000 },
  { nome: 'Patriolino Ribeiro', lat: -3.7619, lng: -38.4919, population: 12000 },
  { nome: 'Engenheiro Luciano Cavalcante', lat: -3.7719, lng: -38.4958, population: 22000 },
  { nome: 'Praia do Futuro I', lat: -3.7389, lng: -38.4458, population: 18000 },
  { nome: 'Praia do Futuro II', lat: -3.7619, lng: -38.4319, population: 14000 },
  { nome: 'Vicente Pinzón', lat: -3.7289, lng: -38.4689, population: 48000 },
  { nome: 'De Lourdes (Dunas)', lat: -3.7389, lng: -38.4619, population: 6000 },

  // --- CENTRO & ÁREA INTERMEDIÁRIA ---
  { nome: 'Centro', lat: -3.7319, lng: -38.5267, population: 30000 },
  { nome: 'Fátima (Bairro de Fátima)', lat: -3.7558, lng: -38.5289, population: 32000 },
  { nome: 'Benfica', lat: -3.7458, lng: -38.5358, population: 16000 },
  { nome: 'Montese', lat: -3.7689, lng: -38.5458, population: 58000 },
  { nome: 'Parreão', lat: -3.7619, lng: -38.5358, population: 15000 },
  { nome: 'Damas', lat: -3.7558, lng: -38.5489, population: 16000 },
  { nome: 'Parquelândia', lat: -3.7389, lng: -38.5558, population: 22000 },
  { nome: 'São Gerardo', lat: -3.7319, lng: -38.5489, population: 18000 },
  { nome: 'Monte Castelo', lat: -3.7258, lng: -38.5458, population: 24000 },
  { nome: 'Jacarecanga', lat: -3.7189, lng: -38.5358, population: 16000 },
  { nome: 'Carlito Pamplona', lat: -3.7158, lng: -38.5519, population: 35000 },
  { nome: 'Pirambu', lat: -3.7089, lng: -38.5489, population: 25000 },
  { nome: 'Farias Brito', lat: -3.7358, lng: -38.5419, population: 15000 },
  { nome: 'Rodolfo Teófilo', lat: -3.7458, lng: -38.5519, population: 25000 },
  { nome: 'Amadeu Furtado', lat: -3.7489, lng: -38.5589, population: 12000 },
  { nome: 'Parque Araxá', lat: -3.7419, lng: -38.5489, population: 11000 },

  // --- ZONA SUL & POLOS COMERCIAIS ---
  { nome: 'Messejana Centro', lat: -3.8319, lng: -38.4989, population: 50000 },
  { nome: 'Cambeba', lat: -3.8058, lng: -38.4919, population: 22000 },
  { nome: 'Cidade dos Funcionários', lat: -3.7919, lng: -38.4989, population: 35000 },
  { nome: 'Edson Queiroz', lat: -3.7789, lng: -38.4789, population: 30000 },
  { nome: 'Parque Manibura', lat: -3.7919, lng: -38.4889, population: 14000 },
  { nome: 'Jardim das Oliveiras', lat: -3.7858, lng: -38.5089, population: 38000 },
  { nome: 'Água Fria', lat: -3.7858, lng: -38.4819, population: 18000 },
  { nome: 'José de Alencar', lat: -3.8189, lng: -38.4858, population: 24000 },
  { nome: 'Lagoa Redonda', lat: -3.8389, lng: -38.4689, population: 32000 },
  { nome: 'Curió', lat: -3.8258, lng: -38.4819, population: 16000 },
  { nome: 'Guajeru', lat: -3.8419, lng: -38.4858, population: 22000 },
  { nome: 'Paupina', lat: -3.8558, lng: -38.5089, population: 30000 },
  { nome: 'Coaçu', lat: -3.8489, lng: -38.4619, population: 12000 },
  { nome: 'Passaré', lat: -3.8089, lng: -38.5358, population: 65000 },
  { nome: 'Castelão', lat: -3.8058, lng: -38.5189, population: 18000 },
  { nome: 'Dias Macedo', lat: -3.7958, lng: -38.5289, population: 16000 },

  // --- ZONA OESTE & POLOS POPULARES ---
  { nome: 'Maraponga', lat: -3.7919, lng: -38.5689, population: 42000 },
  { nome: 'Mondubim', lat: -3.8119, lng: -38.5789, population: 85000 },
  { nome: 'Parangaba', lat: -3.7789, lng: -38.5619, population: 40000 },
  { nome: 'Vila Pery', lat: -3.7858, lng: -38.5619, population: 28000 },
  { nome: 'Itaperi', lat: -3.7889, lng: -38.5489, population: 26000 },
  { nome: 'Serrinha', lat: -3.7789, lng: -38.5419, population: 32000 },
  { nome: 'Bela Vista', lat: -3.7558, lng: -38.5619, population: 22000 },
  { nome: 'Pici', lat: -3.7519, lng: -38.5719, population: 45000 },
  { nome: 'Henrique Jorge', lat: -3.7619, lng: -38.5858, population: 35000 },
  { nome: 'João XXIII', lat: -3.7689, lng: -38.5889, population: 20000 },
  { nome: 'Antônio Bezerra', lat: -3.7458, lng: -38.5919, population: 30000 },
  { nome: 'Autran Nunes', lat: -3.7558, lng: -38.5958, population: 26000 },
  { nome: 'Dom Lustosa', lat: -3.7589, lng: -38.5789, population: 14000 },
  { nome: 'Conjunto Ceará (I e II)', lat: -3.7689, lng: -38.6089, population: 55000 },
  { nome: 'Granja Portugal', lat: -3.7819, lng: -38.6019, population: 45000 },
  { nome: 'Granja Lisboa', lat: -3.7958, lng: -38.6089, population: 58000 },
  { nome: 'Bom Jardim', lat: -3.7919, lng: -38.5958, population: 42000 },
  { nome: 'Siqueira', lat: -3.8058, lng: -38.5919, population: 30000 },
  { nome: 'Conjunto Esperança', lat: -3.8158, lng: -38.5958, population: 22000 },
  { nome: 'José Walter (Prefeito José Walter)', lat: -3.8289, lng: -38.5519, population: 50000 }
];

// ============================================================================
// CURITIBA - PR (68 Bairros Oficiais com GPS)
// ============================================================================
export const CURITIBA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- ÁREA CENTRAL & NOBRES ---
  { nome: 'Batel', lat: -25.4419, lng: -49.2889, population: 12000 },
  { nome: 'Água Verde', lat: -25.4519, lng: -49.2819, population: 52000 },
  { nome: 'Bigorrilho (Champagnat)', lat: -25.4319, lng: -49.2989, population: 30000 },
  { nome: 'Centro', lat: -25.4284, lng: -49.2733, population: 38000 },
  { nome: 'Centro Cívico', lat: -25.4158, lng: -49.2689, population: 6000 },
  { nome: 'Juvevê', lat: -25.4119, lng: -49.2619, population: 14000 },
  { nome: 'Cabral', lat: -25.4058, lng: -49.2558, population: 15000 },
  { nome: 'Alto da Glória', lat: -25.4219, lng: -49.2619, population: 7000 },
  { nome: 'Alto da XV', lat: -25.4289, lng: -49.2519, population: 10000 },
  { nome: 'Cristo Rei', lat: -25.4358, lng: -49.2458, population: 15000 },
  { nome: 'Jardim Social', lat: -25.4189, lng: -49.2419, population: 7000 },
  { nome: 'Hugo Lange', lat: -25.4158, lng: -49.2489, population: 4500 },
  { nome: 'Mercês', lat: -25.4219, lng: -49.2919, population: 16000 },
  { nome: 'São Francisco', lat: -25.4219, lng: -49.2758, population: 7000 },
  { nome: 'Ahú', lat: -25.4019, lng: -49.2689, population: 12000 },
  { nome: 'Prado Velho', lat: -25.4519, lng: -49.2589, population: 9000 },
  { nome: 'Rebouças', lat: -25.4458, lng: -49.2689, population: 18000 },
  { nome: 'Jardim Botânico (Curitiba)', lat: -25.4419, lng: -49.2419, population: 7500 },

  // --- ZONA NORTE & OESTE ---
  { nome: 'Santa Felicidade', lat: -25.4019, lng: -49.3319, population: 30000 },
  { nome: 'Cascatinha', lat: -25.4089, lng: -49.3119, population: 3000 },
  { nome: 'Vista Alegre', lat: -25.4119, lng: -49.2989, population: 10000 },
  { nome: 'Pilarzinho', lat: -25.3958, lng: -49.2889, population: 30000 },
  { nome: 'Bom Retiro', lat: -25.4119, lng: -49.2789, population: 7000 },
  { nome: 'São Lourenço', lat: -25.3919, lng: -49.2658, population: 7000 },
  { nome: 'Boa Vista', lat: -25.3858, lng: -49.2458, population: 35000 },
  { nome: 'Bacacheri', lat: -25.3989, lng: -49.2319, population: 25000 },
  { nome: 'Tingui', lat: -25.3889, lng: -49.2258, population: 14000 },
  { nome: 'Santa Cândida', lat: -25.3619, lng: -49.2289, population: 32000 },
  { nome: 'Tarumã', lat: -25.4289, lng: -49.2258, population: 10000 },
  { nome: 'Bairro Alto', lat: -25.4119, lng: -49.2089, population: 50000 },
  { nome: 'Atuba', lat: -25.3789, lng: -49.2089, population: 16000 },
  { nome: 'Santo Inácio', lat: -25.4219, lng: -49.3319, population: 6000 },
  { nome: 'Campina do Siqueira', lat: -25.4389, lng: -49.3119, population: 9000 },
  { nome: 'Seminário', lat: -25.4458, lng: -49.3019, population: 7500 },
  { nome: 'Vila Izabel', lat: -25.4558, lng: -49.2958, population: 12000 },
  { nome: 'Campo Comprido', lat: -25.4489, lng: -49.3389, population: 30000 },
  { nome: 'Mossunguê (Ecoville)', lat: -25.4419, lng: -49.3358, population: 12000 },

  // --- ZONA SUL & LESTE (ALTO COMÉRCIO & POPULAÇÃO) ---
  { nome: 'Portão', lat: -25.4719, lng: -49.2919, population: 45000 },
  { nome: 'Guaíra', lat: -25.4689, lng: -49.2719, population: 12000 },
  { nome: 'Parolin', lat: -25.4589, lng: -49.2689, population: 14000 },
  { nome: 'Lindóia', lat: -25.4789, lng: -49.2789, population: 12000 },
  { nome: 'Fanny', lat: -25.4789, lng: -49.2689, population: 15000 },
  { nome: 'Novo Mundo', lat: -25.4858, lng: -49.2889, population: 50000 },
  { nome: 'Capão Raso', lat: -25.5019, lng: -49.2958, population: 40000 },
  { nome: 'Pinheirinho', lat: -25.5219, lng: -49.2989, population: 55000 },
  { nome: 'Xaxim', lat: -25.4989, lng: -49.2619, population: 60000 },
  { nome: 'Hauer', lat: -25.4789, lng: -49.2519, population: 15000 },
  { nome: 'Uberaba', lat: -25.4719, lng: -49.2219, population: 75000 },
  { nome: 'Jardim das Américas', lat: -25.4558, lng: -49.2319, population: 16000 },
  { nome: 'Guabirotuba', lat: -25.4619, lng: -49.2458, population: 12000 },
  { nome: 'Boqueirão', lat: -25.5089, lng: -49.2419, population: 75000 },
  { nome: 'Alto Boqueirão', lat: -25.5319, lng: -49.2458, population: 55000 },
  { nome: 'Sítio Cercado', lat: -25.5389, lng: -49.2719, population: 120000 },
  { nome: 'Ganchinho', lat: -25.5619, lng: -49.2719, population: 14000 },
  { nome: 'Umbará', lat: -25.5719, lng: -49.2919, population: 20000 },
  { nome: 'Tatuquara', lat: -25.5689, lng: -49.3319, population: 60000 },
  { nome: 'Campo de Santana', lat: -25.5889, lng: -49.3219, population: 40000 },
  { nome: 'Caximba', lat: -25.6119, lng: -49.3458, population: 3000 },
  { nome: 'Cidade Industrial (CIC Norte / Centro / Sul)', lat: -25.4989, lng: -49.3458, population: 180000 },
  { nome: 'São Miguel', lat: -25.5219, lng: -49.3619, population: 6000 },
  { nome: 'Augusta', lat: -25.4789, lng: -49.3619, population: 5000 },
  { nome: 'Riviera', lat: -25.4619, lng: -49.3619, population: 500 },
  { nome: 'Fazendinha', lat: -25.4758, lng: -49.3189, population: 30000 },
  { nome: 'Santa Quitéria', lat: -25.4589, lng: -49.3089, population: 15000 }
];

// ============================================================================
// PORTO ALEGRE - RS (66 Bairros Oficiais com GPS)
// ============================================================================
export const PORTO_ALEGRE_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- ZONA CENTRAL & NOBRES ---
  { nome: 'Moinhos de Vento', lat: -30.0258, lng: -51.2019, population: 9000 },
  { nome: 'Bela Vista', lat: -30.0358, lng: -51.1919, population: 11000 },
  { nome: 'Petrópolis', lat: -30.0419, lng: -51.1819, population: 40000 },
  { nome: 'Menino Deus', lat: -30.0519, lng: -51.2219, population: 32000 },
  { nome: 'Centro Histórico', lat: -30.0346, lng: -51.2177, population: 40000 },
  { nome: 'Cidade Baixa', lat: -30.0419, lng: -51.2189, population: 18000 },
  { nome: 'Bom Fim', lat: -30.0358, lng: -51.2119, population: 12000 },
  { nome: 'Rio Branco', lat: -30.0389, lng: -51.2019, population: 20000 },
  { nome: 'Mont\'Serrat', lat: -30.0289, lng: -51.1919, population: 14000 },
  { nome: 'Higienópolis', lat: -30.0189, lng: -51.1889, population: 14000 },
  { nome: 'Auxiliadora', lat: -30.0219, lng: -51.1958, population: 10000 },
  { nome: 'Floresta', lat: -30.0219, lng: -51.2119, population: 16000 },
  { nome: 'Independência', lat: -30.0289, lng: -51.2089, population: 7000 },
  { nome: 'Praia de Belas', lat: -30.0558, lng: -51.2319, population: 3000 },
  { nome: 'Santana', lat: -30.0489, lng: -51.2089, population: 22000 },
  { nome: 'Santa Cecília', lat: -30.0419, lng: -51.2019, population: 6000 },
  { nome: 'Jardim Botânico (Porto Alegre)', lat: -30.0519, lng: -51.1819, population: 14000 },

  // --- ZONA NORTE & NORDESTE ---
  { nome: 'Passo d\'Areia', lat: -30.0119, lng: -51.1719, population: 30000 },
  { nome: 'São João', lat: -30.0089, lng: -51.1919, population: 15000 },
  { nome: 'Navegantes', lat: -30.0019, lng: -51.2019, population: 5000 },
  { nome: 'São Geraldo', lat: -30.0089, lng: -51.2089, population: 9000 },
  { nome: 'Humaitá', lat: -29.9789, lng: -51.1858, population: 12000 },
  { nome: 'Farrapos', lat: -29.9889, lng: -51.1958, population: 18000 },
  { nome: 'Sarandi', lat: -29.9989, lng: -51.1289, population: 65000 },
  { nome: 'Rubem Berta', lat: -30.0119, lng: -51.1119, population: 90000 },
  { nome: 'Jardim Lindóia', lat: -30.0058, lng: -51.1619, population: 8000 },
  { nome: 'Jardim São Pedro', lat: -30.0019, lng: -51.1789, population: 4500 },
  { nome: 'Jardim Floresta', lat: -30.0019, lng: -51.1689, population: 4000 },
  { nome: 'Jardim Itati', lat: -30.0089, lng: -51.1558, population: 5000 },
  { nome: 'Cristo Redentor', lat: -30.0119, lng: -51.1558, population: 16000 },
  { nome: 'Vila Ipiranga', lat: -30.0189, lng: -51.1519, population: 24000 },
  { nome: 'Boa Vista', lat: -30.0258, lng: -51.1719, population: 9000 },
  { nome: 'Chácara das Pedras', lat: -30.0358, lng: -51.1619, population: 7500 },
  { nome: 'Três Figueiras', lat: -30.0319, lng: -51.1719, population: 4000 },
  { nome: 'Jardim Europa', lat: -30.0289, lng: -51.1589, population: 5000 },
  { nome: 'Jardim do Salso', lat: -30.0519, lng: -51.1689, population: 6000 },

  // --- ZONA SUL & LESTE ---
  { nome: 'Tristeza', lat: -30.1119, lng: -51.2489, population: 18000 },
  { nome: 'Ipanema (Porto Alegre)', lat: -30.1389, lng: -51.2289, population: 20000 },
  { nome: 'Cristal', lat: -30.0789, lng: -51.2419, population: 25000 },
  { nome: 'Santa Tereza', lat: -30.0689, lng: -51.2289, population: 50000 },
  { nome: 'Medianeira', lat: -30.0658, lng: -51.2158, population: 14000 },
  { nome: 'Glória', lat: -30.0689, lng: -51.2019, population: 10000 },
  { nome: 'Camaquã', lat: -30.0989, lng: -51.2389, population: 22000 },
  { nome: 'Cavalhada', lat: -30.1058, lng: -51.2219, population: 26000 },
  { nome: 'Nonoai', lat: -30.0889, lng: -51.2189, population: 32000 },
  { nome: 'Vila Nova', lat: -30.1189, lng: -51.2089, population: 40000 },
  { nome: 'Vila Assunção', lat: -30.0989, lng: -51.2589, population: 5000 },
  { nome: 'Vila Conceição', lat: -30.1089, lng: -51.2589, population: 2000 },
  { nome: 'Pedra Redonda', lat: -30.1289, lng: -51.2419, population: 1000 },
  { nome: 'Guarujá', lat: -30.1589, lng: -51.2189, population: 8000 },
  { nome: 'Serraria', lat: -30.1789, lng: -51.2089, population: 10000 },
  { nome: 'Hípica', lat: -30.1619, lng: -51.1889, population: 25000 },
  { nome: 'Restinga', lat: -30.1419, lng: -51.1419, population: 65000 },
  { nome: 'Belém Novo', lat: -30.1989, lng: -51.1719, population: 16000 },
  { nome: 'Lami', lat: -30.2389, lng: -51.0889, population: 5000 },
  { nome: 'Pitinga', lat: -30.1289, lng: -51.1119, population: 5000 },
  { nome: 'Lomba do Pinheiro', lat: -30.0989, lng: -51.1189, population: 58000 },
  { nome: 'Partenon', lat: -30.0589, lng: -51.1889, population: 50000 },
  { nome: 'Coronel Aparício Borges', lat: -30.0689, lng: -51.1889, population: 24000 },
  { nome: 'Vila João Pessoa', lat: -30.0619, lng: -51.1789, population: 12000 },
  { nome: 'Agronomia', lat: -30.0719, lng: -51.1358, population: 14000 }
];

// ============================================================================
// GOIÂNIA - GO (52 Setores e Bairros Principais com GPS)
// ============================================================================
export const GOIANIA_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- SETORES NOBRES & CENTRO-SUL ---
  { nome: 'Setor Bueno', lat: -16.7019, lng: -49.2719, population: 55000 },
  { nome: 'Setor Marista', lat: -16.6989, lng: -49.2619, population: 30000 },
  { nome: 'Setor Oeste', lat: -16.6889, lng: -49.2719, population: 32000 },
  { nome: 'Setor Sul', lat: -16.6919, lng: -49.2558, population: 18000 },
  { nome: 'Setor Central', lat: -16.6819, lng: -49.2558, population: 40000 },
  { nome: 'Jardim Goiás', lat: -16.7019, lng: -49.2389, population: 28000 },
  { nome: 'Setor Pedro Ludovico', lat: -16.7119, lng: -49.2558, population: 35000 },
  { nome: 'Setor Nova Suíça', lat: -16.7089, lng: -49.2789, population: 16000 },
  { nome: 'Setor Bela Vista', lat: -16.7189, lng: -49.2519, population: 15000 },
  { nome: 'Alto da Glória', lat: -16.7089, lng: -49.2389, population: 12000 },
  { nome: 'Setor Aeroporto', lat: -16.6789, lng: -49.2689, population: 14000 },
  { nome: 'Setor Coimbra', lat: -16.6858, lng: -49.2858, population: 16000 },
  { nome: 'Setor Campinas (Histórico/Comercial)', lat: -16.6719, lng: -49.2958, population: 25000 },
  { nome: 'Setor dos Funcionários', lat: -16.6758, lng: -49.2889, population: 9000 },
  { nome: 'Setor Universitário', lat: -16.6819, lng: -49.2389, population: 22000 },
  { nome: 'Setor Leste Universitário', lat: -16.6858, lng: -49.2358, population: 14000 },
  { nome: 'Setor Leste Vila Nova', lat: -16.6719, lng: -49.2419, population: 18000 },
  { nome: 'Setor Crimeia Leste', lat: -16.6619, lng: -49.2458, population: 10000 },
  { nome: 'Setor Crimeia Oeste', lat: -16.6589, lng: -49.2589, population: 9000 },
  { nome: 'Setor Norte Ferroviário (Polo Moda da 44)', lat: -16.6658, lng: -49.2589, population: 15000 },

  // --- ZONA SUL & SUDOESTE ---
  { nome: 'Jardim América', lat: -16.7119, lng: -49.2819, population: 45000 },
  { nome: 'Parque Amazônia', lat: -16.7289, lng: -49.2789, population: 30000 },
  { nome: 'Setor Sudoeste', lat: -16.7089, lng: -49.3019, population: 20000 },
  { nome: 'Vila Rosa', lat: -16.7358, lng: -49.2819, population: 16000 },
  { nome: 'Setor Serrinha', lat: -16.7189, lng: -49.2658, population: 8000 },
  { nome: 'Jardim Atlântico', lat: -16.7389, lng: -49.2958, population: 24000 },
  { nome: 'Parque Santa Fé', lat: -16.7689, lng: -49.3458, population: 12000 },
  { nome: 'Setor Faiçalville', lat: -16.7489, lng: -49.3119, population: 18000 },
  { nome: 'Setor Novo Horizonte', lat: -16.7219, lng: -49.3258, population: 26000 },
  { nome: 'Setor União', lat: -16.7158, lng: -49.3189, population: 15000 },
  { nome: 'Jardim Planalto', lat: -16.7058, lng: -49.3158, population: 14000 },

  // --- ZONA NORTE, NOROESTE & LESTE ---
  { nome: 'Setor Santa Genoveva', lat: -16.6389, lng: -49.2258, population: 12000 },
  { nome: 'Setor Jaó', lat: -16.6458, lng: -49.2158, population: 8000 },
  { nome: 'Setor Negrão de Lima', lat: -16.6619, lng: -49.2319, population: 16000 },
  { nome: 'Guanabara (Jardim Guanabara)', lat: -16.6219, lng: -49.2189, population: 35000 },
  { nome: 'Setor Urias Magalhães', lat: -16.6458, lng: -49.2658, population: 18000 },
  { nome: 'Setor Balneário Meia Ponte', lat: -16.6189, lng: -49.2689, population: 22000 },
  { nome: 'Vila Nova', lat: -16.6719, lng: -49.2458, population: 20000 },
  { nome: 'Setor Morada do Sol', lat: -16.6189, lng: -49.3319, population: 25000 },
  { nome: 'Setor Finsocial', lat: -16.6289, lng: -49.3219, population: 20000 },
  { nome: 'Setor Vila Mutirão', lat: -16.6158, lng: -49.3458, population: 22000 },
  { nome: 'Setor Cândida de Morais', lat: -16.6458, lng: -49.3189, population: 15000 },
  { nome: 'Setor Santos Dumont', lat: -16.6358, lng: -49.3458, population: 12000 },
  { nome: 'Setor Tremendão', lat: -16.5989, lng: -49.3519, population: 16000 },
  { nome: 'Vila Canaã', lat: -16.6919, lng: -49.3158, population: 14000 },
  { nome: 'Setor Cidade Jardim', lat: -16.6858, lng: -49.3119, population: 18000 },
  { nome: 'Setor Rodoviário', lat: -16.6789, lng: -49.3089, population: 8000 },
  { nome: 'Setor São José', lat: -16.6619, lng: -49.3019, population: 12000 },
  { nome: 'Setor Capuava', lat: -16.6658, lng: -49.3219, population: 15000 },
  { nome: 'Parque Tremendão', lat: -16.5989, lng: -49.3519, population: 18000 }
];

// ============================================================================
// RECIFE - PE (56 Bairros Oficiais com GPS)
// ============================================================================
export const RECIFE_NEIGHBORHOODS: Partial<IBGEDistrict>[] = [
  // --- ZONA SUL & LITORAL ---
  { nome: 'Boa Viagem', lat: -8.1258, lng: -34.9019, population: 125000 },
  { nome: 'Pina', lat: -8.0889, lng: -34.8889, population: 35000 },
  { nome: 'Brasília Teimosa', lat: -8.0819, lng: -34.8789, population: 20000 },
  { nome: 'Imbiribeira', lat: -8.1058, lng: -34.9158, population: 52000 },
  { nome: 'Ipsep', lat: -8.1189, lng: -34.9289, population: 26000 },
  { nome: 'Ibura', lat: -8.1289, lng: -34.9458, population: 55000 },
  { nome: 'Jordão', lat: -8.1419, lng: -34.9389, population: 22000 },
  { nome: 'Cohab', lat: -8.1119, lng: -34.9658, population: 70000 },

  // --- ZONA NORTE & NOBRES ---
  { nome: 'Graças', lat: -8.0419, lng: -34.9019, population: 22000 },
  { nome: 'Espinheiro', lat: -8.0389, lng: -34.8958, population: 12000 },
  { nome: 'Aflitos', lat: -8.0358, lng: -34.8989, population: 7000 },
  { nome: 'Parnamirim', lat: -8.0319, lng: -34.9119, population: 9000 },
  { nome: 'Jaqueira', lat: -8.0358, lng: -34.9089, population: 3000 },
  { nome: 'Casa Forte', lat: -8.0289, lng: -34.9219, population: 18000 },
  { nome: 'Poço da Panela', lat: -8.0319, lng: -34.9289, population: 5000 },
  { nome: 'Santana (Recife)', lat: -8.0389, lng: -34.9189, population: 4000 },
  { nome: 'Tamarineira', lat: -8.0289, lng: -34.9058, population: 15000 },
  { nome: 'Rosarinho', lat: -8.0289, lng: -34.8989, population: 8000 },
  { nome: 'Encruzilhada', lat: -8.0319, lng: -34.8889, population: 30000 },
  { nome: 'Torreão', lat: -8.0389, lng: -34.8819, population: 5000 },
  { nome: 'Campo Grande', lat: -8.0219, lng: -34.8819, population: 32000 },
  { nome: 'Hipódromo', lat: -8.0289, lng: -34.8819, population: 4000 },
  { nome: 'Casa Amarela', lat: -8.0189, lng: -34.9189, population: 35000 },
  { nome: 'Alto José do Pinho', lat: -8.0189, lng: -34.9089, population: 14000 },
  { nome: 'Alto do Mandu', lat: -8.0189, lng: -34.9289, population: 9000 },
  { nome: 'Vasco da Gama (Recife)', lat: -8.0089, lng: -34.9189, population: 30000 },
  { nome: 'Nova Descoberta', lat: -8.0019, lng: -34.9289, population: 38000 },
  { nome: 'Dois Irmãos', lat: -8.0119, lng: -34.9458, population: 6000 },
  { nome: 'Apipucos', lat: -8.0189, lng: -34.9419, population: 4000 },
  { nome: 'Monteiro', lat: -8.0258, lng: -34.9358, population: 3000 },

  // --- ZONA CENTRAL & OESTE ---
  { nome: 'Recife Antigo (Bairro do Recife)', lat: -8.0619, lng: -34.8719, population: 1500 },
  { nome: 'Santo Antônio', lat: -8.0658, lng: -34.8789, population: 3000 },
  { nome: 'São José', lat: -8.0719, lng: -34.8858, population: 10000 },
  { nome: 'Boa Vista', lat: -8.0589, lng: -34.8919, population: 18000 },
  { nome: 'Santo Amaro', lat: -8.0489, lng: -34.8819, population: 30000 },
  { nome: 'Soledade', lat: -8.0519, lng: -34.8958, population: 6000 },
  { nome: 'Ilha do Leite (Polo Médico)', lat: -8.0658, lng: -34.8958, population: 2000 },
  { nome: 'Ilha de Joana Bezerra', lat: -8.0719, lng: -34.8989, population: 14000 },
  { nome: 'Paissandu', lat: -8.0619, lng: -34.8989, population: 3000 },
  { nome: 'Derby', lat: -8.0519, lng: -34.9019, population: 3500 },
  { nome: 'Madalena', lat: -8.0519, lng: -34.9119, population: 26000 },
  { nome: 'Torre', lat: -8.0419, lng: -34.9119, population: 20000 },
  { nome: 'Prado (Recife)', lat: -8.0619, lng: -34.9119, population: 18000 },
  { nome: 'Zumbi', lat: -8.0519, lng: -34.9219, population: 6000 },
  { nome: 'Cordeiro', lat: -8.0458, lng: -34.9319, population: 42000 },
  { nome: 'Iputinga', lat: -8.0358, lng: -34.9419, population: 58000 },
  { nome: 'Várzea (Polo Universitário UFPE)', lat: -8.0519, lng: -34.9619, population: 75000 },
  { nome: 'Cidade Universitária', lat: -8.0519, lng: -34.9519, population: 6000 },
  { nome: 'Engenho do Meio', lat: -8.0589, lng: -34.9419, population: 12000 },
  { nome: 'San Martin', lat: -8.0689, lng: -34.9289, population: 28000 },
  { nome: 'Afogados', lat: -8.0789, lng: -34.9119, population: 38000 },
  { nome: 'Mustardinha', lat: -8.0719, lng: -34.9219, population: 12000 },
  { nome: 'Mangueira (Recife)', lat: -8.0819, lng: -34.9189, population: 14000 },
  { nome: 'Areias', lat: -8.0989, lng: -34.9358, population: 35000 },
  { nome: 'Estância', lat: -8.0889, lng: -34.9358, population: 30000 },
  { nome: 'Barro', lat: -8.0989, lng: -34.9519, population: 32000 },
  { nome: 'Tejipió', lat: -8.0919, lng: -34.9619, population: 10000 }
];
